export default {
    methods: {
        // TODO: unused, delete
        promptForDescription(file) {
            swal({
                text: uLang('app.add_description_confirmation'),
                content: {
                    element: 'input',
                    attributes: {
                        value: file.description ? file.description : '',
                        placeholder: uLang('app.description')
                    }
                },
                buttons: {
                    cancel: {
                        text: uLang('app.no'),
                        visible: true,
                        className: "btn btn-secondary",
                        closeModal: true,
                        value: null
                    },
                    confirm: {
                        text: uLang('app.save'),
                        visible: true,
                        className: "btn btn-brand",
                        closeModal: true,
                        value: true
                    },
                }
            }).then((value) => {
                if (value === null) {
                    return;
                }

                window.axios.put(
                    route('resource.files.updateMetaData', { file: file.id }),
                    { description: value }
                ).then(response => {
                    this.onFileMetaDataUpdated(response.data);
                })
            });
        },
        onFileMetaDataUpdated(file) {
            //
        }
    }
}
